import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  EventEmitter,
  Output,
} from '@angular/core';

@Component({
  selector: 'bulk-buttons',
  templateUrl: './bulk-buttons.component.html',
  styleUrls: ['./bulk-buttons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BulkButtonsComponent implements OnInit {
  @Input() buttons: { text: string, value: string; icon: string }[];
  @Output() bulkAction = new EventEmitter();
  @Input() buttonsActivated: boolean;

  constructor() {}

  ngOnInit(): void {}

  onClicked(selectedElement: any) {
    this.bulkAction.emit(selectedElement?.srcElement?.value);
  }
}
